import React from 'react'
import { DataDebug } from './DataDebug'

export const ObjectDebug = ({ object, ...rest }) => {
    return <DataDebug {...rest}>{JSON.stringify(object, null, 2)}</DataDebug>
}
